konnyScript(function($){

  /* 스와들 비교 슬라이드 */
  $('[id^=\'swd_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = '#swd_swiper_slide'+index+' .swiper-pagination';
      var slidePage2 = '#swd_swiper_slide'+index+' .swiper-progress';
      var slideScr = '#swd_swiper_slide'+index+' .swiper-scrollbar';
      var slideNext = '#swd_swiper_slide'+index+' .swiper-button-next';
      var slidePrev = '#swd_swiper_slide'+index+' .swiper-button-prev';
      var swdSlide = new Swiper(this,{
          slidesPerView:1.2,
          slidesPerGroup:1,
          spaceBetween:10,
          centeredSlides:false,
          observer:true,
          observeParents:true,
          //loop: true,
          pagination:true,
          pagination:{
              el:slidePage2,
              type :'progressbar'
          },
          scrollbar:{
              el:slideScr,
              hide:true,
          },
          navigation: {
              nextEl: slideNext,
              prevEl: slidePrev,
          },
      });
  });

  
  /* 프로모션 내 슬라이드 */

  $('[id^=\'eprd_swiper_slide\']').each(function(index){
      index = index+1;
      var slidePage1 = '#eprd_swiper_slide'+index+' .swiper-pagination';
      var slidePage2 = '#eprd_swiper_slide'+index+' .swiper-progress';
      var slideScr = '#eprd_swiper_slide'+index+' .swiper-scrollbar';
      var slideNext = '#eprd_swiper_slide'+index+' .swiper-button-next';
      var slidePrev = '#eprd_swiper_slide'+index+' .swiper-button-prev';
      var mallSlide = new Swiper(this,{
          slidesPerView:1,
          slidesPerGroup:1,
          spaceBetween:0,
          centeredSlides:false,
          //loop: true,
          pagination:true,
          pagination:{
              el:slidePage2,
              type : 'progressbar'
          },
          scrollbar:{
              el:slideScr,
              hide:true,
          },
          navigation: {
              nextEl: slideNext,
              prevEl: slidePrev,
          },
      });
  });

});